import * as React from "react"

function getText() {
    return <div>
        <h2>Persondatabeskyttelse</h2>
        <p>I henhold til EU’s databeskyttelsesforordning (GDPR) vil vi i det følgende oplyse dig om, hvordan styrelsen håndterer de personoplysninger, som vi modtager og behandler om dig.</p>
        <h3>Vi er dataansvarlig – hvordan kontakter du os?</h3>
        <p>
            Færdselsstyrelsen er dataansvarlig for behandlingen af de personoplysninger, som vi modtager om dig. <br />
            Hvis du har spørgsmål til styrelsens behandling af dine personoplysninger, er du altid velkommen til at kontakte os eller Transport- og Boligministeriets uafhængige databeskyttelsesrådgiver via kontaktoplysningerne nedenfor:
        </p>
        <p>
            <u>Færdselsstyrelsens kontaktoplysninger:</u><br />
            Sorsigvej 35<br />
            6760 Ribe<br />
            Telefon: 7221 8899 <br />
            E-mail: <a href="mailto:info@fstyr.dk">info@fstyr.dk</a><br />
            CVR-nr.: 40850031
        </p>
        <p>
            <u>Databeskyttelsesrådgivers kontaktoplysninger:</u><br />
            E-mail: <a href="mailto:dpo@tbst.dk">dpo@tbst.dk</a><br />
            Telefon: 41780531
        </p>
        <p>
            Beredskabsstyrelsen er dataansvarlig for behandlingen af de personoplysninger, som vi modtager om dig vedrørende ADR-beviser. <br />
            Hvis du har spørgsmål til Beredskabsstyrelsens behandling af dine personoplysninger, er du altid velkommen til at kontakte Beredskabsstyrelsen via kontaktoplysningerne nedenfor:
        </p>
        <p>
            <u>Beredskabsstyrelsens kontaktoplysninger:</u><br />
            Datavej 16<br />
            3460 Birkerød<br />
            Telefon: 7285 2000<br />
            E-mail: <a href="mailto:brs@brs.dk">brs@brs.dk</a><br />
            CVR-nr.: 52990319
        </p>
        <p>
            Databeskyttelsesrådgivers kontaktoplysninger (Beredskabsstyrelsen):<br />
            Christina Carstensen <br />
            Telefon: 7285 2276 <br />
            E-mail: <a href="mailto:brs-ktp-dpo@brs.dk">brs-ktp-dpo@brs.dk</a>
        </p>
        {/* END */}
        <h3>Formålene og retsgrundlaget for behandling af personoplysninger</h3>
        <p>Vi behandler dine personoplysningerne til følgende formål:</p>
        <p>
            Personoplysninger bruges til at vurdere, om en fører lever op til gældende lovkrav og pligter– herunder også til brug ved mulige tilsyn.<br />
            De nærmere angivelser af retsgrundlag og formål vil blive mere udspecificeret ved de respektive ansøgningsblanketter.
        </p>

        <h3>Kategorier af personoplysninger</h3>
        <p>Vi behandler følgende kategorier af personoplysninger:</p>
        <p>For- og efternavn, CPR nr. adresse, e-mail adresse, tlf.nr.</p>

        <h3>Vi videregiver eller overlader dine personoplysninger til følgende modtagere</h3>
        <p>Den konkrete videregivelse af de respektive personoplysninger vil blive mere udspecificeret i de respektive ansøgningsblanketter.</p>

        <h3>Hvor personoplysningerne stammer fra</h3>
        <p>Vi behandler de personoplysninger, som automatisk registreres og logges i forbindelse din ansøgningsproces.</p>

        <h3>Opbevaring af personoplysninger</h3>
        <p>
            Når du logger ind, oprettes du som bruger af systemet og vi opbevarer oplysninger om dig. Så længe du ikke har påbegyndt eller indsendt en ansøgning til os, opbevarer vi dine oplysninger i et begrænset tidsrum, hvorefter vi sletter dem. Påbegyndte og ikke indsendte ansøgninger, som ikke har været aktiveret i 1 år, vil forventeligt blive slettet.<br />
            Vi opbevarer dine personoplysninger i de indsendte ansøgninger i vores sagsbehandlingssystem og sletter dem forventeligt 5 år efter den seneste tilladelses udløb.
         </p>
        <p>De oplysninger, styrelsen skal journalisere, afleveres løbende til Rigsarkivet efter arkivlovens regler og Statens Arkivers bestemmelser herom. Oplysninger vi modtager, der ikke er omfattet af styrelsens pligt til at journalisere, vil blive slettet.</p>
        <p>
            Retsgrundlag for ovenstående følger af:<br />
            Bekendtgørelse af arkivloven LBK 1201 af 28. september 2016 Kapitel 4 aflevering af statslige arkivalier.
        </p>

        <h3>Dine rettigheder</h3>
        <p>Du har efter databeskyttelsesforordningen en række rettigheder i forhold til vores behandling af oplysninger om dig. Hvis du vil gøre brug af dine rettigheder skal du kontakte os.</p>
        <p>
            <u>Ret til at se oplysninger</u><br />
            Du har ret til at få indsigt i de oplysninger om dig, som vi behandler (indsigtsret), eller til at søge om aktindsigt.
        </p>
        <p>
            <u>Ret til berigtigelse</u><br />
            Du har ret til at få urigtige oplysninger om dig selv rettet.
        </p>
        <p>
            <u>Ret til sletning</u><br />
            I særlige tilfælde har du ret til at få slettet oplysninger om dig, inden tidspunktet for vores almindelige generelle sletning indtræffer. Det gælder alene oplysninger, som ikke er journaliseringspligtige.
        </p>
        <p>Du kan læse mere om dine rettigheder i Datatilsynets vejledning om de registreredes rettigheder, som du finder på <a href="http://www.datatilsynet.dk/">www.datatilsynet.dk</a>.</p>

        <h3>Klage til Datatilsynet</h3>
        <p>Du har ret til at indgive en klage til Datatilsynet, hvis du er utilfreds med den måde, Færdselsstyrelsen eller Beredskabsstyrelsen behandler dine personoplysninger på. Du finder Datatilsynets kontaktoplysninger på <a href="http://www.datatilsynet.dk/">www.datatilsynet.dk</a>.</p>
    </div >
}

export default getText